import { Swiper } from 'swiper';
import {Navigation} from "swiper/modules";
Swiper.use([Navigation]);

export default () => {
    const nodeSelectors = {
        container: '[js-video-gallery-slider="container"]',
        slider: '[js-video-gallery-slider="slider"]',
        pagination: '[js-video-gallery-slider="pagination"]',
        prev: '[js-video-gallery-slider="prev"]',
        next: '[js-video-gallery-slider="next"]',
        play: '[js-video-gallery-slider="play-button"]',
        close: '[js-video-gallery-slider="close"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.slider)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            let slider = new Swiper(sliderEl, {
                slidesPerView: 5,
                spaceBetween: 15,
                speed: 500,
                autoplay: {
                    delay: 2500
                },
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                },
                pagination: {
                    el: container.querySelector(nodeSelectors.pagination),
                    clickable: true
                },
                breakpoints: {
                    300: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 480px
                    768: {
                        slidesPerView: 3
                    },
                    // when window width is >= 640px
                    1024: {
                        slidesPerView: 4
                    },
                    1100: {
                        slidesPerView: 5
                    }
                }
            });
        })

        $(nodeSelectors.play).on('click', function(){
            let currentVideo = $(this).data('video');
            $('.video-popup').fadeIn();
            $('.video-popup iframe').attr('src', 'https://www.youtube.com/embed/'+currentVideo+'?autoplay=1')
        })

        // $(nodeSelectors.close).on('click', function(){
        //     $('.video-popup').fadeOut();
        //     $('.video-popup iframe').attr('src', '')
        // })

        $('.video-popup').on('click', function (event) {
            const clickedOutsideIframe = $(event.target).closest('.iframe-holder').length === 0;

            if (clickedOutsideIframe) {
                $('.video-popup').fadeOut();
                $('.video-popup iframe').attr('src', '');
            }
        });
    }

    return Object.freeze({
        init,
    })
}